// Libraries.
import { fork } from 'redux-saga/effects'

// Manager channels.
import watchDeviceEvents from './devices'
import watchTrackManagerEvents from './trackManager'
import watchSessionManagerEvents from './sessionManager'
import watchMediaManagerEvents from './mediaManager'

// Re-export each channel.
export { default as watchDeviceEvents } from './devices'
export { default as watchTrackManagerEvents } from './trackManager'
export { default as watchMediaManagerEvents } from './mediaManager'

/**
 * Combine all of the manager channels into a single function.
 * @method watchManagers
 * @param  {Object} managers Webrtc stack managers.
 */
export default function * watchManagers (managers, webRTC) {
  yield fork(watchDeviceEvents, managers.devices)
  yield fork(watchTrackManagerEvents, managers.track)
  yield fork(watchSessionManagerEvents, managers.sessionManager, webRTC)
  yield fork(watchMediaManagerEvents, managers.media)
}
